
import React from 'react';
import { Link } from 'react-router-dom';

interface HeaderLogoProps {
  navigateTo: string;
}

const HeaderLogo = ({ navigateTo }: HeaderLogoProps) => {
  return (
    <div className="mr-8">
      <Link to={navigateTo} className="flex items-center">
        <span className="text-directpress-blue text-lg font-bold">
          Direct<span className="text-directpress-orange">Press</span>
        </span>
      </Link>
    </div>
  );
};

export default HeaderLogo;
